import React, { useEffect, useState } from "react";
import { api, formatApiError } from "@/lib/api";
import PageHeader from "@/components/PageHeader";
import { BarChart, Bar, XAxis, YAxis, Tooltip, ResponsiveContainer, CartesianGrid, Cell } from "recharts";
import { useI18n } from "@/lib/i18n";

export default function Reports() {
  const { t } = useI18n();
  const [data, setData] = useState(null);
  const [error, setError] = useState("");
  const load = () => {
    setError(""); setData(null);
    api.get("/reports/summary").then((r) => setData(r.data)).catch((e) => setError(formatApiError(e.response?.data?.detail)));
  };
  useEffect(() => { load(); }, []);
  if (error) return <div><PageHeader title={t("reports.title")} subtitle={t("reports.subtitle")} /><div className="p-4 sm:p-8"><div className="bg-white border border-red-200 p-8 text-center"><div className="font-bold text-red-700">Raporlar alınamadı</div><div className="text-sm text-slate-500 mt-1">{error}</div><button onClick={load} className="mt-4 px-4 py-2 bg-blue-600 text-white text-sm font-semibold">Tekrar Dene</button></div></div></div>;
  if (!data) return <div><PageHeader title={t("reports.title")} subtitle={t("reports.subtitle")} /><div className="p-4 sm:p-8"><div className="bg-white border border-slate-200 p-10 text-center text-slate-500">Raporlar hazırlanıyor…</div></div></div>;

  const barColors = ["#2563EB", "#0EA5E9", "#16A34A", "#F59E0B", "#DC2626", "#8B5CF6", "#EC4899", "#14B8A6", "#EAB308", "#64748B"];

  return (
    <div>
      <PageHeader title={t("reports.title")} subtitle={t("reports.subtitle")} />
      <div className="p-4 sm:p-8 grid grid-cols-1 lg:grid-cols-2 gap-4">
        <div className="bg-white border border-slate-200 p-4 sm:p-5 min-w-0">
          <h3 className="font-display font-bold text-sm uppercase tracking-wider text-slate-700 mb-3">{t("reports.monthly")}</h3>
          {data.monthly.length === 0 ? <div className="text-slate-400 py-8 text-center">{t("common.no_data")}</div> :
            <div className="min-w-[320px]"><ResponsiveContainer width="100%" height={320}>
              <BarChart data={data.monthly}>
                <CartesianGrid strokeDasharray="3 3" stroke="#E2E8F0" />
                <XAxis dataKey="month" fontSize={11} stroke="#64748B" />
                <YAxis fontSize={11} stroke="#64748B" />
                <Tooltip contentStyle={{ fontSize: 12, border: "1px solid #CBD5E1" }} />
                <Bar dataKey="pallets" fill="#2563EB" name="Yükleme Birimi" />
                <Bar dataKey="plans" fill="#F59E0B" name="Plan" />
              </BarChart>
            </ResponsiveContainer></div>}
        </div>

        <div className="bg-white border border-slate-200 p-4 sm:p-5 min-w-0">
          <h3 className="font-display font-bold text-sm uppercase tracking-wider text-slate-700 mb-3">{t("reports.top_products")}</h3>
          {data.top_products.length === 0 ? <div className="text-slate-400 py-8 text-center">{t("common.no_data")}</div> :
            <div className="min-w-[320px]"><ResponsiveContainer width="100%" height={320}>
              <BarChart data={data.top_products} layout="vertical">
                <CartesianGrid strokeDasharray="3 3" stroke="#E2E8F0" />
                <XAxis type="number" fontSize={11} stroke="#64748B" />
                <YAxis type="category" dataKey="sku" fontSize={11} stroke="#64748B" width={70} />
                <Tooltip contentStyle={{ fontSize: 12 }} />
                <Bar dataKey="count" name={t("reports.box")}>
                  {data.top_products.map((_, i) => <Cell key={i} fill={barColors[i % barColors.length]} />)}
                </Bar>
              </BarChart>
            </ResponsiveContainer></div>}
        </div>

        <div className="lg:col-span-2 bg-white border border-slate-200 overflow-hidden">
          <div className="border-b border-slate-200 px-5 py-3">
            <h3 className="font-display font-bold text-sm uppercase tracking-wider text-slate-700">{t("reports.monthly_detail")}</h3>
          </div>
          <div className="overflow-x-auto">
          <table className="data-table w-full min-w-[560px]">
            <thead><tr><th>{t("reports.month")}</th><th className="text-right">{t("reports.plan")}</th><th className="text-right">Yükleme Birimi</th><th className="text-right">{t("reports.box")}</th><th className="text-right">Kg</th></tr></thead>
            <tbody>
              {data.monthly.map((m) => (
                <tr key={m.month}>
                  <td className="font-mono">{m.month}</td>
                  <td className="text-right data-cell">{m.plans}</td>
                  <td className="text-right data-cell">{m.pallets}</td>
                  <td className="text-right data-cell">{m.boxes}</td>
                  <td className="text-right data-cell">{m.kg.toFixed(1)}</td>
                </tr>
              ))}
              {data.monthly.length === 0 && <tr><td colSpan={5} className="text-center py-8 text-slate-400">{t("common.no_data")}</td></tr>}
            </tbody>
          </table>
          </div>
        </div>
      </div>
    </div>
  );
}
